import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ApiService } from '../../service/api.service';
import { AuthenticationService } from '../../service/authentication.service';
import { UtilService } from '../../service/util.service';
import { ToastService } from '../../service/toast.service';
import { Constants } from '../../constants/constants';
import { SearchResultsComponent } from '../../search-results/search-results.component';
import { SearchDataService } from '../../service/search-data.service';
import { isNullOrUndefined } from 'util';
import { DeviceService } from '../../service/device.service';
import { MessageConstants } from '../../constants/message-constants';
import { EnrollmentConstants } from '../../constants/enrollment-constants';

const PAGE_SIZE: number = 25;

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.scss']
})
export class DevicesComponent implements OnInit {

  readonly CHOOSE_FILE: string = "Select File";

  device: any = {};
  deviceList: any = [];
  deviceImportEntryTypes: any = ['QUICK_ENTRY', 'DETAILED_ENTRY'];
  selectedDeviceEntryType: string = "QUICK_ENTRY";
  deviceQuickEntryFile: File = null;
  deviceDetailedEntryFile: File = null;
  accountType: string;
  fleetId: String = null;
  account: any = {};
  importFile: File = null;

  @ViewChild('addDeviceForm', { static: true }) public addDeviceForm: NgForm;
  // invalidMake: boolean = false;
  selectedDevice: any;
  selectedVin: any;
  isViewDeviceDetail: boolean = false;
  // brands: any[] = ["NISSAN", "INFINITI"];
  // minYear: number;
  // maxYear: number;

  //Search result storage variable
  @ViewChild('searchResult') searchResult: SearchResultsComponent;
  searchedDeviceList: Array<any>;
  selectedSearchItemForView: string;
  showSearchResult: boolean = false;
  isSearchResult: boolean = false;

  importFileName: string = this.CHOOSE_FILE;
  @ViewChild('devicesCompImportDeviceInput') devicesCompImportDeviceInput: ElementRef;
  @ViewChild('devicesCompRemoveDevicesFromAccountInput', { static: true }) devicesCompRemoveDevicesFromAccountInput: ElementRef;

  selectedDevices: Array<any> = [];

  previousPage: number;
  currentPage: number;
  nextPage: number;

  //Filters
  // devicesMasterData = [];
  deviceFilters: any = {};
  // selectedFilterOptions: Array<string> = ["all", "all", "all"];
  enrollmentEligibleFilterOptions: Array<boolean> = [true, false];
  /* enrollmentStatusFilterOptions: Array<string> = ["NOT_APPLICABLE", "NOT_ENROLLED", "ENROLLMENT_IN_PROGRESS", "ENROLLED", "ENROLLMENT_RETRY", "ENROLLMENT_FAILED", "UNENROLLMENT_IN_PROGRESS", 
    "UNENROLLED", "UNENROLLMENT_RETRY", "UNENROLLMENT_FAILED"]; */
  enrollmentStatusFilterOptions: Array<string> = ["NOT_APPLICABLE", "NOT_ENROLLED", "ENROLLMENT_IN_PROGRESS|ENROLLMENT_RETRY|ENROLLMENT_INITIATED", "ENROLLED", "ENROLLMENT_FAILED", "UNENROLLMENT_IN_PROGRESS|UNENROLLMENT_RETRY|UNENROLLMENT_INITIATED",
    "UNENROLLED", "UNENROLLMENT_FAILED"];
  // deviceStatusFilterOptions: Array<string> = ["ORDERED", "DELIVERED", "INACTIVE", "ASSIGNED", "PENDING", "ACTIVE", "DELETED"];
  deviceStatusFilterOptions: Array<string> = ["NONE", "ATTACHED", "ENABLED", "LINKED", "UNLINKED"];
  // deviceStatusFilterOptions: Array<string> = ["NONE", "ATTACHED", "ENABLED", "LINKED"];
  certificatesFilterOptions: Array<string> = [];
  selectedCertificateFilterOption = null;
  enrollDevices = EnrollmentConstants.ENROLL_NOW;
  unenrollDevices = EnrollmentConstants.UNENROLL_NOW;
  deviceServiceProviderType = Constants.VEHICLE_SERVICE_PROVIDER;

  reviewDeviceModalMessages = {
    header: "Delete Device(s)",
    message: "Confirm deleting devices?",
    note: "Once defleeted, data on these VINs are remotely wiped and VINs would no longer be part of the fleet, and cannot be automatically added back to the account."
  }
  masterDeviceList: any;

  constructor(private apiService: ApiService, public authService: AuthenticationService, private utilService: UtilService, private toastService: ToastService, private searchService: SearchDataService,
    private deviceService: DeviceService) {

  }


  ngOnInit() {
    this.initFilters();
    this.searchService.searchedData.subscribe(data => {
      this.processSearchResult();
    });
    // this.minYear = 2010;
    //var date = new Date();
    // this.maxYear = new Date().getFullYear() + 1;
    // console.log("year range: ", this.minYear, "-", this.maxYear);
    this.account = this.utilService.selectedRentalFleetAccount;
    // this.getPaginatedAccountDevices(0);
    // this.getAccountCertificates();
    this.getDevices('DONGLE_DEVICE');
  }

  initFilters() {
    this.deviceFilters = {
      "enrollmentEligibility": null,
      "enrollmentReady": null,
      "enrollmentStatus": null,
      "ignitionType": null,
      "make": null,
      "model": null,
      "oemCustomerIds": [],
      "servicesActivated": null,
      "status": null,
      "tcuType": null,
      "telematicsAvailability": null,
      "trim": null,
      "year": null
    }
  }

  private processSearchResult() {
    this.searchedDeviceList = this.searchService.getSearchedDataForType(Constants.VEHICLES);
    if (this.searchedDeviceList && this.searchedDeviceList.length > 0) {
      this.showSearchResult = true;
      this.selectedSearchItemForView = null;
      this.closeDeviceDetailClicked(null);
    } else {
      this.showSearchResult = false;
    }
  }

  ngOnDestroy() {
    this.searchService.resetPreviousSearchResult();
  }

  onSearchItemDetail(searchItem: string) {
    this.selectedSearchItemForView = searchItem;
  }

  /* uploadDeviceLogoClicked() {
    document.getElementById("uploadLogoInput").click();
  } */

  /* uploadDeviceLogo(event) {
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      let file: File = fileList[0];
      let formData: FormData = new FormData();
      formData.append('file', file, file.name);
      formData.append('folder', 'device/' + this.account.id);

      console.log("Upload image name : ", file.name);

      this.utilService.showSpinner();
      this.apiService.uploadFleetLogo(formData).then((data) => {
        this.utilService.hideSpinner();
        console.log("Response is :: ", data);
        this.device["logo"] = data.imageUrl;
      }).catch((error) => {
        console.log("err : ", error);
        if (error.status == Constants.HTTP_UNAUTHORISED) {
          this.authService.refreshToken().then(() => {
            this.utilService.hideSpinner();
            console.log("refresh token api executed");
            this.uploadDeviceLogo(event);
          });
        }
        else {
          this.utilService.hideSpinner();
          if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
          else this.toastService.showError(Constants.UNKNOWN_ERROR);
        }
      });
    }
  } */

  onCreateDevice(form: NgForm) {
    console.log("adding device with data :: empty method", this.device);
    /* if (form.valid) {
      const requestPayload = {
        "type": "VEHICLE",
        "provisioningData": {
          "enterpriseId": this.authService.loggedInUser.enterpriseId,
          "accountId": this.account.id,
          "vin": this.device.vin,
          "make": this.device.make.toUpperCase(),
          "model": this.device.model.toUpperCase(),
          "year": this.device.year,
          "logo": this.device.logo,
          "color": this.device.color
        }
      }
      console.log("Adding device with data : ", requestPayload);
      this.addAccountDevice(requestPayload); 

    }*/
  }

  /*  addAccountDevice(requestPayload: any) {
     this.utilService.showSpinner();
     this.apiService.addVehicleDevice(requestPayload, vin).then((data) => {
       this.utilService.hideSpinner();
       console.log("add device response ::", data);
       this.toastService.showSuccess(data.message);
       document.getElementById("closeAddDevice").click();
       this.resetAddDeviceForm();
       this.getPaginatedAccountDevices(0);
     }).catch((error) => {
       console.log("err : ", error);
       if (error.status == Constants.HTTP_UNAUTHORISED) {
         this.authService.refreshToken().then(() => {
           this.utilService.hideSpinner();
           console.log("refresh token api executed");
           this.addAccountDevice(requestPayload);
         });
       }
       else {
         this.utilService.hideSpinner();
         if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
         else this.toastService.showError(Constants.UNKNOWN_ERROR);
       }
     });
   } */

  /* getPaginatedAccountDevices(page: number) {
    var requestPayload = this.getDeviceFilters();
    this.utilService.showSpinner();
    this.apiService.getPaginatedAccountDevices(requestPayload, page, PAGE_SIZE).then((data) => {
      this.utilService.hideSpinner();
      console.log("devices response::", data);
      // shu: hardcoded
      data = this.getDummyDeviceList();
      this.processDeviceResponse(data);
      this.invalidMake = false
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getPaginatedAccountDevices(page);
        });
      }
      else {
        this.utilService.hideSpinner();
        this.invalidMake = false
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  } */

  getDeviceFilters() {
    if (this.deviceFilters.enrollmentEligibility) {
      this.deviceFilters.enrollmentReady = true;
    } else {
      this.deviceFilters.enrollmentReady = null;
    }
    return this.deviceFilters;
  }

  private processDeviceResponse(deviceResponse: any) {
    // this.deviceList = deviceResponse.devices;
    this.deviceList = deviceResponse;
    this.masterDeviceList = JSON.parse(JSON.stringify(deviceResponse));

    console.log("devices ::", this.deviceList);
    // this.devicesMasterData = this.deviceList.map(x => Object.assign({}, x));

    // this.nextPage = deviceResponse.nextPage;
    // this.currentPage = deviceResponse.curPage;
    // this.previousPage = deviceResponse.prevPage;
  }

  setVariablesInDeviceList() {
    if (isNullOrUndefined(this.deviceList) || this.deviceList.length == 0) return;
    this.deviceList.forEach(device => {
      if (device.enrollmentEligibility == false) {
        device['enrollmentStatus'] = this.enrollmentStatusFilterOptions[0];
      } else if (isNullOrUndefined(device.enrollmentStatus) || device.enrollmentStatus == '') {
        device['enrollmentStatus'] = this.enrollmentStatusFilterOptions[1];
      } else if (device['enrollmentStatus'] == "ENROLLMENT_RETRY") {
        device['enrollmentStatus'] = this.enrollmentStatusFilterOptions[2];
      }
    });
  }

  deviceSelected(device) {
    this.selectedDevice = JSON.parse(JSON.stringify(device));
    // delete this.selectedDevice["vin"];
    // this.selectedDevice["vin"]=null;
    // this.selectedDevice["vin"] = '234';
    // this.selectedVin = JSON.parse(JSON.stringify(device.vin));
    //this.prepareSelectedDevice();
    // document.getElementById("openViewServicePackage").click();
    this.isViewDeviceDetail = true;
  }

  closeDeviceDetailClicked(data) {
    this.isViewDeviceDetail = false;
    this.getDevices('DONGLE_DEVICE');
  }

  onDeviceEntryTypeSelected() {
    console.log("Device Entry Upload Type::", this.selectedDeviceEntryType);
  }

  uploadDeviceEntries() {
    let formData: FormData = new FormData();
    if (this.selectedDeviceEntryType == this.deviceImportEntryTypes[0])
      formData.append('file', this.deviceQuickEntryFile, this.deviceQuickEntryFile.name);
    if (this.selectedDeviceEntryType == this.deviceImportEntryTypes[1])
      formData.append('file', this.deviceDetailedEntryFile, this.deviceDetailedEntryFile.name);

    this.uploadCsvFile(formData);
  }

  uploadCsvFile(formData: FormData) {
    this.utilService.showSpinner();
    this.apiService.uploadCsvFile(formData).then((data) => {
      this.utilService.hideSpinner();
      console.log("device entry response :: ", data);
      this.toastService.showSuccess(data.message);
      document.getElementById("closeImportDevice").click();
      document.getElementById("closeRemoveDevice").click();
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.uploadCsvFile(formData);
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  onDeviceFileSelected(files: FileList) {
    this.deviceQuickEntryFile = null;
    this.deviceDetailedEntryFile = null;
    // https://www.youtube.com/watch?v=YkvqLNcJz3Y
    if (this.isFileSelected(files)) {
      let file: File = files.item(0);
      this.updateFileName(file);
      if (this.isCsvFile(file.name) && this.isValidDeviceEntryFile(file.name)) {
        if (this.selectedDeviceEntryType == this.deviceImportEntryTypes[0]) {
          this.deviceQuickEntryFile = file;
        }
        if (this.selectedDeviceEntryType == this.deviceImportEntryTypes[1]) {
          this.deviceDetailedEntryFile = file;
        }
      } else {
        this.resetDeviceImport();
      }
    } else {
      this.resetDeviceImport();
    }
  }

  updateFileName(file: File) {
    var fileName = file.name;
    // if(fileName && fileName.length > 35) {
    //   fileName = fileName.substring(0,35) + '...';
    // }
    this.importFileName = fileName;
  }

  isFileSelected(files: FileList) {
    if (files && files.length > 0)
      return true;
    return false;
  }

  isCsvFile(name: string) {
    let splitStr = name.split('.');
    let extension = splitStr[splitStr.length - 1];
    if (extension.toLowerCase() != 'csv') {
      this.toastService.showError("Please select .csv file only");
      return false;
    }
    return true;
  }

  isValidDeviceEntryFile(name: string) {
    let splitStr = name.split('_');
    if (splitStr.length < 4) {
      if (this.selectedDeviceEntryType == this.deviceImportEntryTypes[0])
        this.toastService.showError("Invalid file name format. Expected file name format: NCC_DeviceQuickEntry_" + this.account.id + "_05132019101630.csv");
      if (this.selectedDeviceEntryType == this.deviceImportEntryTypes[1])
        this.toastService.showError("Invalid file name format. Expected file name format: NCC_DeviceDetailedEntry_" + this.account.id + "_05132019101630.csv");
      return false;
    }
    let importType = splitStr[1];
    let accountId = splitStr[2];
    if (importType != "DeviceQuickEntry" && importType != "DeviceDetailedEntry") {
      if (this.selectedDeviceEntryType == this.deviceImportEntryTypes[0])
        this.toastService.showError("Invalid file name format. Expected file name format: NCC_DeviceQuickEntry_" + this.account.id + "_05132019101630.csv");
      if (this.selectedDeviceEntryType == this.deviceImportEntryTypes[1])
        this.toastService.showError("Invalid file name format. Expected file name format: NCC_DeviceDetailedEntry_" + this.account.id + "_05132019101630.csv");
      return false;
    }
    if (accountId != this.account.id) {
      this.toastService.showError("AccountId in filename mismatch with fleet accountId.");
      return false;
    }
    return true;
  }

  onFileSelected(files: FileList, type: string) {
    this.importFile = null;
    if (this.isFileSelected(files)) {
      let file: File = files.item(0);
      this.updateFileName(file);
      if (this.isCsvFile(file.name) && this.isValidFileName(file.name, type)) {
        this.importFile = file;
      } else {
        this.resetRemoveDeviceImport();
      }
    } else {
      this.resetRemoveDeviceImport();
    }
  }

  uploadFile() {
    let formData: FormData = new FormData();
    formData.append('file', this.importFile, this.importFile.name);
    this.uploadCsvFile(formData);
  }

  isValidFileName(name: string, type: string) {
    let splitStr = name.split('_');
    if (splitStr.length < 4) {
      this.toastService.showError("Invalid file name format. Expected file name format: NCC_" + type + "_" + this.account.id + "_05132019101630.csv");
      return false;
    }
    let importType = splitStr[1];
    let accountId = splitStr[2];
    if (importType != type) {
      this.toastService.showError("Invalid file name format. Expected file name format: NCC_" + type + "_" + this.account.id + "_05132019101630.csv");
      return false;
    }
    if (accountId != this.account.id) {
      this.toastService.showError("The accountId in the filename doesn't match the selected fleet's accountId.");
      return false;
    }
    return true;
  }

  resetAddDeviceForm() {
    this.addDeviceForm.resetForm();
    this.device = {};
  }

  onDeviceImportClose() {
    this.selectedDeviceEntryType = this.deviceImportEntryTypes[0];
    this.resetDeviceImport();
  }

  resetDeviceImport() {
    this.devicesCompImportDeviceInput.nativeElement.value = null;
    this.importFileName = this.CHOOSE_FILE;
    this.deviceQuickEntryFile = null;
    this.deviceDetailedEntryFile = null;
  }

  resetRemoveDeviceImport() {
    this.devicesCompRemoveDevicesFromAccountInput.nativeElement.value = null;
    this.importFileName = this.CHOOSE_FILE;
    this.importFile = null;
  }

  /* getPreviousPage() {
    this.getPaginatedAccountDevices(this.previousPage);
  }

  getNextPage() {
    this.getPaginatedAccountDevices(this.nextPage);
  } */

  onDeviceSelectionChange(checked: boolean, device: any) {
    var deviceIndex = this.selectedDevices.findIndex(v => v.vin === device.vin);

    if (checked && deviceIndex == -1) {
      this.selectedDevices.push(device);
    } else if (!checked && deviceIndex >= 0) {
      this.selectedDevices.splice(deviceIndex, 1);
    }
  }

  onDeleteDevices() {
    console.log("selected devices::", this.selectedDevices);
    document.getElementById("openReviewDevices").click();
  }

  resetSelectedDevices() {
    this.selectedDevices = [];
    this.resetCheckbox();
  }

  resetCheckbox() {
    var items = document.getElementsByName('checkbox');
    for (var i = 0; i < items.length; i++) {
      if (items[i]["type"] == 'checkbox')
        items[i]["checked"] = false;
    }
  }

  /* getAccountCertificates() {
    this.utilService.showSpinner();
    this.apiService.getCertificates().then((certificates) => {
      this.utilService.hideSpinner();
      console.log("certificate list : ", certificates);
      if (certificates != null && certificates.length > 0) {
        this.certificatesFilterOptions = certificates.map(function (certificate) {
          return certificate['oemCustomerId'];
        });
      }
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getAccountCertificates();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  } */

  /* onCertificateChange() {
    this.deviceFilters.oemCustomerIds = this.selectedCertificateFilterOption == null ? [] : [this.selectedCertificateFilterOption];
    this.getPaginatedAccountDevices(0);
  } */

  isDeviceSelected(device: string): boolean {
    if (isNullOrUndefined(this.selectedDevices) || this.selectedDevices.length == 0) return false;
    return this.selectedDevices.some(v => v.vin === device);
  }

  /* reviewDevicesSubmit(devices) {
    this.selectedDevices = devices;
    this.defleetDevices();
  } */

  getDeviceLogo(device): string {
    return this.deviceService.getDeviceLogo(device);
  }

  /* defleetDevices() {
    var requestPayload = this.getDefleetDevicesPayload();
    this.utilService.showSpinner();
    this.apiService.defleetDevices(requestPayload).then((data) => {
      this.utilService.hideSpinner();
      console.log("Defleet device(s) initiated: ", data);
      this.toastService.showSuccess(MessageConstants.DEFLEET_VEHICLES_INITIATED);
      document.getElementById("closeReviewDevices").click();
      this.resetSelectedDevices();
      this.getPaginatedAccountDevices(0);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.defleetDevices();
        });
      }
      else {
        this.utilService.hideSpinner();
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  } */

  getDefleetDevicesPayload() {
    let devices = this.selectedDevices.map((device) => device.vin);
    return {
      "devices": devices
    }
  }

  refreshDeviceList() {
    // this.getPaginatedAccountDevices(this.currentPage);
    this.getDevices('DONGLE_DEVICE');
  }

  /* getDevices() {
    this.deviceList = this.getDummyDeviceList();
  } */

  getDevices(deviceType) {
    var requestPayload = this.getDeviceFilters();
    this.utilService.showSpinner();
    this.apiService.getDevices(deviceType).then((data) => {
      this.utilService.hideSpinner();
      console.log("devices response::", data);
      this.processDeviceResponse(data);
    }).catch((error) => {
      console.log("err : ", error);
      if (error.status == Constants.HTTP_UNAUTHORISED) {
        this.authService.refreshToken().then(() => {
          this.utilService.hideSpinner();
          console.log("refresh token api executed");
          this.getDevices(deviceType);
        });
      }
      else {
        this.utilService.hideSpinner();
        // this.invalidMake = false
        if (error && error.error && error.error.message) this.toastService.showError(error.error.message);
        else this.toastService.showError(Constants.UNKNOWN_ERROR);
      }
    });
  }

  filterSelected() {
    
    this.deviceList = this.masterDeviceList.filter(device => device.dongleStatus == this.deviceFilters.status);
    if (!this.deviceFilters.status) {
      this.deviceList = this.masterDeviceList;
    }
  }
}
